// extracted by mini-css-extract-plugin
export default {"successBtn":"styles_successBtn__8xkAY","icon":"styles_icon__jq+BK","cloneIcon":"styles_cloneIcon__aLuUa"};